import React from 'react';

const ButtonLightBlue = ({type,onSubmit,disabled,text}) => {

  return (
    <button 
        type={type || 'submit'} 
        className='font-semibold text-center block bg-custom-light-blue text-white border-custom-custom-light-blue rounded-md w-full min-h-[45px]'
        disabled={disabled ? true : false}
        onSubmit={onSubmit || null}
    >
        {text}
    </button>
  );
};

export default ButtonLightBlue;
